if(typeof window !== 'undefined' && window.pixwel?.env === 'production') {
	import('aws-rum-web').then(({ AwsRum }) => {
		/** @type {import('aws-rum-web').AwsRumConfig} */
		const config = {
			sessionSampleRate: 1,
			endpoint: 'https://dataplane.rum.us-west-2.amazonaws.com',
			telemetries: ['performance', 'errors', 'http'],
			allowCookies: true,
			enableXRay: false,
			signing: false // If you have a public resource policy and wish to send unsigned requests please set this to false
		};

		const APPLICATION_ID = 'f74ab654-997b-41ca-ac87-54ea6d751dc7';
		const APPLICATION_VERSION = '1.0.0';
		const APPLICATION_REGION = 'us-west-2';

		try {
			const rum = new AwsRum(
				APPLICATION_ID,
				APPLICATION_VERSION,
				APPLICATION_REGION,
				config
			);
			window.awsRum = rum;
		}
		catch{
			// Ignore errors thrown during CloudWatch RUM web client initialization
		}
	});
}
